import { buildDashboardTabNotificationsPath } from "../utils/dashboardTabNotifications";

const MODULE_TO_TAB = {
  marketplace: "rfq",
  procurement: "rfq",
  contract_manufacturing: "cm",
  infrastructure: "infra",
  approval: "p2p",
  logistics: "logistics",
  quality_inspection: "qa",
  auction: "auctions",
  payment: "rfq",
};

const TYPE_TO_TAB = {
  p2p_approval_assigned: "p2p",
  approval_assigned: "p2p",
  approval_approved: "p2p",
  approval_rejected: "p2p",
  approval_sent_back: "p2p",
};

const SCOPED_MODULES = new Set(Object.keys(MODULE_TO_TAB));

export function resolveBuyerTabForNotification(notification) {
  if (!notification) return null;
  const moduleName = String(notification.module_name || "").toLowerCase();
  if (!SCOPED_MODULES.has(moduleName)) return null;
  const type = String(notification.notification_type || "").toLowerCase();
  return TYPE_TO_TAB[type] || MODULE_TO_TAB[moduleName] || null;
}

export function notificationBelongsToBuyerTab(notification, tabKey) {
  if (!notification || !tabKey || tabKey === "overview") {
    return SCOPED_MODULES.has(String(notification?.module_name || "").toLowerCase());
  }
  return resolveBuyerTabForNotification(notification) === tabKey;
}

export function buildBuyerTabNotificationsPath(tabKey) {
  return buildDashboardTabNotificationsPath({ dashboard: "buyer", tabKey });
}
